module.exports = __webpack_public_path__ + "img/dev-profile-pic.d42285c1.jpg";